import { useState, useContext } from 'react';
import { AuthContext } from '../../../../context/authContext';
import { getItem, STORAGE_KEYS } from '../../../../services/storage';
import calculadoraNotasApiService from '../../../../services/http/calculadoraNotasApiService';
import documentosApiService from '../../../../services/http/documentosApiService';

function getIdiomaIdPersonales(idioma) {
  return idioma === 'Catalán' ? '2' : '1';
}

function getIdiomaIdEscolares(datosEscolares) {
  const idioma = datosEscolares?.idioma;
  return idioma === 'Catalán' || idioma === 'Catalan' ? '2' : '1';
}

export default function useCiclo(props) {
  const { userOU } = useContext(AuthContext);
  const studentData = getItem(STORAGE_KEYS.STUDENT) ?? {};
  const studentId = studentData.id;
  const empresa = studentData.empresaId;

  const [tooltipBalance, setTooltipBalance] = useState({ tooltipOpen: false });
  const [isLoading, setIsLoading] = useState(false);
  const [collapse, setCollapse] = useState(false);
  const [isToolTipHoursOpened, setIsToolTipHoursOpened] = useState(false);
  const [isToolTipResultOpened, setIsToolTipResultOpened] = useState(false);
  const [modalDate, setModalDate] = useState(false);
  const [modalDocumentType, setModalDocumentType] = useState('');
  const [modalIdioma, setModalIdioma] = useState(false);
  const [fecha, setFecha] = useState('');
  const [fechaFinal, setFechaFinal] = useState('');
  const [notaCiclo, setNotaCiclo] = useState(props.ciclo.nota);

  const defaultIdiomaCertificado = getIdiomaIdEscolares(props.datos.escolares);

  const limpio = (props.nombre || '').replace(/\s*\( Grupo.*?\)$/, '');

  const toggle = (e) => {
    if (
      e.target.id !== '1' &&
      e.target.id !== '2' &&
      e.target.id !== '3' &&
      e.target.id !== 'SENDBOLNOT' &&
      e.target.id !== 'CERCOM' &&
      e.target.id !== 'BOLNOT'
    ) {
      setCollapse((c) => !c);
    }
  };

  const toggleTooltipBalance = () => {
    setTooltipBalance((prev) => ({ tooltipOpen: !prev.tooltipOpen }));
  };

  const toggleHours = () => setIsToolTipHoursOpened((v) => !v);
  const toggleResult = () => setIsToolTipResultOpened((v) => !v);

  const download = async () => {
    setModalDate(false);
    setIsLoading(true);
    const idiomaId = getIdiomaIdPersonales(props.datos.personales.idioma);

    try {
      let blobJustificante = null;
      if (modalDocumentType === 'JUSTIFICANTE') {
        blobJustificante = await documentosApiService.generarJustificante({
          headquarter: empresa,
          id: studentId,
          cursoId: props.ciclo.codigo,
          idiomaId,
          nombre: props.datos.personales.nombre,
          apellidos: props.datos.personales.apellidos,
          pais: props.datos.personales.paisNacimiento,
          dni: props.datos.personales.documento,
          fecha: props.datos.personales.fechaNacimiento,
          grupo: (props.matriculas ?? []).sort((a, b) => b.id - a.id)[0].fecha,
          ciclo: props.ciclo.nombre,
          fechaj: fecha,
          fechaF: fechaFinal,
        });
      } else if (modalDocumentType === 'CERTIFICADO_HORAS_PRESENCIALES') {
        blobJustificante = await documentosApiService.generarCertificadoHorasPresenciales({
          headquarter: empresa,
          id: studentId,
          idiomaId,
          nombre: props.datos.personales.nombre,
          apellidos: props.datos.personales.apellidos,
          dni: props.datos.personales.documento,
          grupo: props.matriculas[props.matriculas.length - 1].fecha,
          fechaj: fecha,
          fechaF: fechaFinal,
        });
      } else {
        throw new Error('No match document type');
      }

      const blobFinal = blobJustificante.slice(0, blobJustificante.size, 'application/pdf');
      const url = URL.createObjectURL(blobFinal);
      window.open(url, '_blank');
    } catch (error) {
      // keep loading false
    } finally {
      setIsLoading(false);
      setModalDocumentType('');
    }
  };

  const openBlobInNewTab = (blob) => {
    const blobFinal = blob.slice(0, blob.size, 'application/pdf');
    const url = URL.createObjectURL(blobFinal);
    window.open(url, '_blank');
  };

  const downloadFile = async (e) => {
    if (e.stopPropagation) e.stopPropagation();

    if (e.target.id === 'CERTIFICADO_HORAS_PRESENCIALES' || e.target.id === 'JUSTIFICANTE') {
      setModalDocumentType(e.target.id);
      setModalDate(true);
      return;
    }

    const idiomaIdEsc = getIdiomaIdEscolares(props.datos.escolares);
    const matriculas = props.matriculas ?? [];
    const lastMatricula = matriculas[matriculas.length - 1];
    const baseDocParams = {
      headquarter: empresa,
      id: studentId,
      cursoId: props.ciclo.codigo,
      idiomaId: idiomaIdEsc,
      nombre: props.datos.personales.nombre,
      apellidos: props.datos.personales.apellidos,
      pais: props.datos.personales.paisNacimiento,
      dni: props.datos.personales.documento,
      fecha: props.datos.personales.fechaNacimiento,
      grupo: lastMatricula?.fecha,
      ciclo: props.ciclo.nombre,
      fechaj: fecha,
    };

    if (e.target.id === 'CERCOM') {
      setModalIdioma(true);
      return;
    }

    if (e.target.id === 'BOLNOT') {
      setIsLoading(true);
      try {
        const blobBolnot = await documentosApiService.generarBolnot({
          headquarter: empresa,
          id: studentId,
          cursoId: props.ciclo.codigo,
          idiomaId: idiomaIdEsc,
        });
        openBlobInNewTab(blobBolnot);
      } catch (error) {
        // ignore
      } finally {
        setIsLoading(false);
      }
      return;
    }

    if (e.target.id === 'FoodCOM') {
      setIsLoading(true);
      try {
        const blob = await documentosApiService.generarCertificadoAlimentos({
          ...baseDocParams,
          grupo: lastMatricula?.fecha,
        });
        openBlobInNewTab(blob);
      } catch (error) {
        // ignore
      } finally {
        setIsLoading(false);
      }
      return;
    }

    if (e.target.id === 'CerMat') {
      setIsLoading(true);
      try {
        const blob = await documentosApiService.generarCertificadoMatricula(baseDocParams);
        openBlobInNewTab(blob);
      } catch (error) {
        // ignore
      } finally {
        setIsLoading(false);
      }
      return;
    }

    if (e.target.id === 'uni') {
      setIsLoading(true);
      try {
        const blob = await documentosApiService.generarCertificadoUni({
          ...baseDocParams,
          n: props.ciclo.nombre,
        });
        openBlobInNewTab(blob);
      } catch (error) {
        // ignore
      } finally {
        setIsLoading(false);
      }
      return;
    }

    if (e.target.id === 'PENDIENTE') {
      setIsLoading(true);
      try {
        const blob = await documentosApiService.generarPendienteJunta(baseDocParams);
        openBlobInNewTab(blob);
      } catch (error) {
        // ignore
      } finally {
        setIsLoading(false);
      }
    }
  };

  const descargarCercomConIdioma = async (idiomaId) => {
    setModalIdioma(false);
    setIsLoading(true);
    try {
      const blobCercom = await documentosApiService.generarCercom({
        headquarter: empresa,
        id: studentId,
        cursoId: props.ciclo.codigo,
        idiomaId,
        nombre: props.ciclo.nombre,
        nalumno: props.datos.personales.nombre,
        napellido: props.datos.personales.apellidos,
        dni: props.datos.personales.documento,
        numMatricula: props.matriculas[0].id,
      });
      openBlobInNewTab(blobCercom);
    } catch (error) {
      // ignore
    } finally {
      setIsLoading(false);
    }
  };

  const handleCalculateNote = async () => {
    try {
      const data = await calculadoraNotasApiService.calcularNotas({
        id: studentId,
        idplan: props.ciclo.codigo,
        idplan2: props.ciclo.codigo2,
        centro: empresa,
      });
      setNotaCiclo(data.notaCiclo);
    } catch (error) {
      setNotaCiclo(props.ciclo.nota);
    }
  };

  return {
    userOU,
    limpio,
    tooltipBalance,
    toggleTooltipBalance,
    isLoading,
    collapse,
    isToolTipHoursOpened,
    isToolTipResultOpened,
    modalDate,
    modalDocumentType,
    modalIdioma,
    setModalIdioma,
    defaultIdiomaCertificado,
    fecha,
    fechaFinal,
    notaCiclo,
    setModalDate,
    setFecha,
    setFechaFinal,
    toggle,
    toggleHours,
    toggleResult,
    download,
    downloadFile,
    descargarCercomConIdioma,
    handleCalculateNote,
  };
}
